export default __webpack_public_path__ + "media/images/backgrounds/leaves-6b3edced8cbe027a03db724ccfeeed95.svg";